// extracted by mini-css-extract-plugin
export default {"container":"tooltip_container__Oi1ng","icon":"tooltip_icon__xa+8z","iconText":"tooltip_iconText__Jhekf","clicked":"tooltip_clicked__PE8dr"};